import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";
import { ReactComponent as CancelGreen } from "../../assets/icons/Abbrechen_22px_gruen.svg";
import { ReactComponent as CancelWhite } from "../../assets/icons/Abbrechen_22px_weiss.svg";
import { ReactComponent as OrdersGreen } from "../../assets/icons/Auftraege_25px_gruen.svg";
import { ReactComponent as OrdersWhite } from "../../assets/icons/Auftraege_25px_weiss.svg";
import { ReactComponent as EditGreen } from "../../assets/icons/Bearbeiten_20px_gruen.svg";
import { ReactComponent as EditWhite } from "../../assets/icons/Bearbeiten_20px_weiss.svg";
import { ReactComponent as UserGreen } from "../../assets/icons/Benutzer_25px_gruen.svg";
import { ReactComponent as UserWhite } from "../../assets/icons/Benutzer_25px_weiss.svg";
import { ReactComponent as CsvExportWhite } from "../../assets/icons/csv_export_22px.weiss.svg";
import { ReactComponent as FilterGreen } from "../../assets/icons/Filtern_20px_gruen.svg";
import { ReactComponent as FilterWhite } from "../../assets/icons/Filtern_20px_weiss.svg";
import { ReactComponent as AddWhite } from "../../assets/icons/Hinzufuegen_15px_weiss.svg";
import { ReactComponent as InvoiceAddressMarkerIcon } from "../../assets/icons/invoice-address-marker.svg";
import { ReactComponent as CalendarGreen } from "../../assets/icons/Kalender_25px_gruen.svg";
import { ReactComponent as CalendarBlack } from "../../assets/icons/Kalender_25px_schwarz.svg";
import { ReactComponent as CalendarWhite } from "../../assets/icons/Kalender_25px_weiss.svg";
import { ReactComponent as Delete } from "../../assets/icons/Loeschen_20px.svg";
import { ReactComponent as DeleteWhite } from "../../assets/icons/Loeschen_20px_weiss.svg";
import { ReactComponent as LoginAsUserIcon } from "../../assets/icons/login-as-user.svg";
import { ReactComponent as Logout } from "../../assets/icons/logout.svg";
import { ReactComponent as MenuBurgerGreen } from "../../assets/icons/Menu_Burger_30px_gruen.svg";
import { ReactComponent as MenuBurgerWhite } from "../../assets/icons/Menu_Burger_30px_weiss.svg";
import { ReactComponent as MenuOpenGreen } from "../../assets/icons/Menu_einklappen_30px_gruen.svg";
import { ReactComponent as MenuOpenWhite } from "../../assets/icons/Menu_einklappen_30px_weiss.svg";
import { ReactComponent as NavigationLeftLastIcon } from "../../assets/icons/navigation-last-left.svg";
import { ReactComponent as NavigationLeftIcon } from "../../assets/icons/navigation-left.svg";
import { ReactComponent as NavigationRightLastIcon } from "../../assets/icons/navigation-right-last.svg";
import { ReactComponent as NavigationRightIcon } from "../../assets/icons/navigation-right.svg";
import { ReactComponent as ArrowDownGreen } from "../../assets/icons/Pfeil_runter_22px_gruen.svg";
import { ReactComponent as ArrowDownWhite } from "../../assets/icons/Pfeil_runter_22px_weiss.svg";
import { ReactComponent as ArrowRightGreen } from "../../assets/icons/Pfeil_rechts_22px_gruen.svg";
import { ReactComponent as ArrowRightWhite } from "../../assets/icons/Pfeil_rechts_22px_weiss.svg";
import { ReactComponent as ArrowUpGreen } from "../../assets/icons/Pfeil_hoch_22px_gruen.svg";
import { ReactComponent as ArrowUpWhite } from "../../assets/icons/Pfeil_hoch_22px_weiss.svg";
import { ReactComponent as ScrollToTop } from "../../assets/icons/Scroll-to-top_H30px_weiss.svg";
import { ReactComponent as ShowHistoryGreen } from "../../assets/icons/show_history_20px_gruen.svg";
import { ReactComponent as ShowHistoryWhite } from "../../assets/icons/show_history_20px_weiss.svg";
import { ReactComponent as SaveGreen } from "../../assets/icons/Speichern_22px_gruen.svg";
import { ReactComponent as SaveWhite } from "../../assets/icons/Speichern_22px_weiss.svg";
import { ReactComponent as BaseDataGreen } from "../../assets/icons/Stammdaten_25px_gruen.svg";
import { ReactComponent as BaseDataWhite } from "../../assets/icons/Stammdaten_25px_weiss.svg";
import { ReactComponent as SearchGreen } from "../../assets/icons/Suchen_25px_gruen.svg";
import { ReactComponent as SearchBlack } from "../../assets/icons/Suchen_25px_schwarz.svg";
import { ReactComponent as SearchWhite } from "../../assets/icons/Suchen_25px_weiss.svg";
import { ReactComponent as SupportGreen } from "../../assets/icons/Support_Hilfe_25px_gruen.svg";
import { ReactComponent as SupportWhite } from "../../assets/icons/Support_Hilfe_25px_weiss.svg";
import { ReactComponent as UserTableIcon } from "../../assets/icons/user-table-icon.svg";
import { ReactComponent as Expand } from "../../assets/icons/expand_icon.svg";
import { ReactComponent as GRSNameLogo } from "../../assets/images/logos/grs_logo.svg";
import { ReactComponent as GRSNameLogoDev } from "../../assets/images/logos/grs_logo_testsystem.svg";
import { ReactComponent as PomPlatform } from "../../assets/images/logos/Verteiler_Meldung.svg";
import { ReactComponent as BatteryPickup } from "../../assets/images/logos/Verteiler_Abholung.svg";

export type IconColor = "green" | "darkGreen" | "white" | "black" | "disabled" | "hover" | "red";

export interface IIconsBaseProps extends SvgIconProps {
  svgColor?: IconColor;
}

export const ExpandIcon: React.FC<IIconsBaseProps> = ({ svgColor: _svgColor = "disabled", ...props }) => {
  return <SvgIcon {...props} viewBox="0 0 20 20" component={Expand} />;
};

export const LogoutSidebarIcon: React.FC<IIconsBaseProps> = ({ svgColor: _svgColor = "disabled", ...props }) => {
  return <SvgIcon {...props} component={Logout} />;
};

export const UserTableOutlined: React.FC<IIconsBaseProps> = ({ svgColor: _svgColor = "disabled", ...props }) => {
  return <SvgIcon {...props} component={UserTableIcon} />;
};

export const LoginAsIcon: React.FC<IIconsBaseProps> = ({ svgColor: _svgColor = "disabled", ...props }) => {
  return <SvgIcon {...props} component={LoginAsUserIcon} />;
};

export const NavigationRightLast: React.FC<IIconsBaseProps> = ({ svgColor: _svgColor = "disabled", ...props }) => {
  return <SvgIcon {...props} component={NavigationRightLastIcon} />;
};

export const NavigationRight: React.FC<IIconsBaseProps> = ({ svgColor: _svgColor = "disabled", ...props }) => {
  return <SvgIcon {...props} component={NavigationRightIcon} />;
};

export const NavigationLeft: React.FC<IIconsBaseProps> = ({ svgColor: _svgColor = "disabled", ...props }) => {
  return <SvgIcon {...props} component={NavigationLeftIcon} />;
};

export const NavigationLeftLast: React.FC<IIconsBaseProps> = ({ svgColor: _svgColor = "disabled", ...props }) => {
  return <SvgIcon {...props} component={NavigationLeftLastIcon} />;
};

export const InvoiceAddressMarker: React.FC<IIconsBaseProps> = ({ svgColor: _svgColor = "disabled", ...props }) => {
  return <SvgIcon {...props} component={InvoiceAddressMarkerIcon} />;
};

export const ScrollToTopIcon: React.FC<IIconsBaseProps> = ({ svgColor: _svgColor = "white", classes, ...props }) => {
  return <SvgIcon {...props} viewBox="0 0 30 30" classes={classes} component={ScrollToTop} />;
};

export const SupportIcon: React.FC<IIconsBaseProps> = ({ svgColor: svgColor = "white", ...props }) => {
  switch (svgColor) {
    case "green":
      return <SvgIcon viewBox="0 0 25 25" {...props} component={SupportGreen} />;
    case "white":
    default:
      return <SvgIcon viewBox="0 0 25 25" {...props} component={SupportWhite} />;
  }
};

export const OrdersIcon: React.FC<IIconsBaseProps> = ({ svgColor: svgColor = "white", ...props }) => {
  switch (svgColor) {
    case "white":
      return <SvgIcon viewBox="0 0 25 25" {...props} component={OrdersWhite} />;
    case "green":
      return <SvgIcon viewBox="0 0 25 25" {...props} component={OrdersGreen} />;
    default:
      return <SvgIcon viewBox="0 0 25 25" {...props} component={OrdersWhite} />;
  }
};

export const UserIcon: React.FC<IIconsBaseProps> = ({ svgColor: svgColor = "white", ...props }) => {
  switch (svgColor) {
    case "white":
      return <SvgIcon {...props} component={UserWhite} />;
    case "green":
      return <SvgIcon {...props} component={UserGreen} />;
    default:
      return <SvgIcon {...props} component={UserGreen} />;
  }
};

export const SearchIcon: React.FC<IIconsBaseProps> = ({ svgColor: svgColor = "black", ...props }) => {
  switch (svgColor) {
    case "white":
      return <SvgIcon {...props} component={SearchWhite} />;
    case "green":
      return <SvgIcon {...props} component={SearchGreen} />;
    default:
      return <SvgIcon {...props} component={SearchBlack} />;
  }
};

export const BaseDataIcon: React.FC<IIconsBaseProps> = ({ svgColor: svgColor = "white", ...props }) => {
  switch (svgColor) {
    case "green":
      return <SvgIcon viewBox="0 0 25 25" {...props} component={BaseDataGreen} />;
    default:
      return <SvgIcon viewBox="0 0 25 25" {...props} component={BaseDataWhite} />;
  }
};

export const SaveIcon: React.FC<IIconsBaseProps> = ({ svgColor: svgColor = "white", ...props }) => {
  switch (svgColor) {
    case "green":
      return <SvgIcon {...props} component={SaveGreen} />;
    default:
      return <SvgIcon {...props} component={SaveWhite} />;
  }
};

export const ArrowDownIcon: React.FC<IIconsBaseProps> = ({ svgColor: svgColor = "white", ...props }) => {
  switch (svgColor) {
    case "green":
      return <SvgIcon {...props} viewBox="0 0 15.913 22" component={ArrowDownGreen} />;
    default:
      return <SvgIcon {...props} viewBox="0 0 15.913 22" component={ArrowDownWhite} />;
  }
};

export const ArrowRightIcon: React.FC<IIconsBaseProps> = ({ svgColor: svgColor = "white", ...props }) => {
  switch (svgColor) {
    case "green":
      return <SvgIcon {...props} viewBox="0 0 22 15.846" component={ArrowRightGreen} />;
    default:
      return <SvgIcon {...props} viewBox="0 0 22 15.846" component={ArrowRightWhite} />;
  }
};

export const ArrowUpIcon: React.FC<IIconsBaseProps> = ({ svgColor: svgColor = "white", ...props }) => {
  switch (svgColor) {
    case "green":
      return <SvgIcon {...props} viewBox="0 0 15.913 22" component={ArrowUpGreen} />;
    default:
      return <SvgIcon {...props} viewBox="0 0 15.913 22" component={ArrowUpWhite} />;
  }
};

export const CancelIcon: React.FC<IIconsBaseProps> = ({ svgColor: svgColor = "white", ...props }) => {
  switch (svgColor) {
    case "green":
    case "red":
      return <SvgIcon {...props} viewBox="0 0 22 22" component={CancelGreen} />;
    default:
      return <SvgIcon {...props} viewBox="0 0 22 22" component={CancelWhite} />;
  }
};

export const EditIcon: React.FC<IIconsBaseProps> = ({ svgColor: svgColor = "white", ...props }) => {
  switch (svgColor) {
    case "green":
      return <SvgIcon viewBox="0 0 20 20" {...props} component={EditGreen} />;
    default:
      return <SvgIcon viewBox="0 0 20 20" {...props} component={EditWhite} />;
  }
};

export const FilterIcon: React.FC<IIconsBaseProps> = ({ svgColor: svgColor = "white", ...props }) => {
  switch (svgColor) {
    case "green":
      return <SvgIcon {...props} viewBox="0 0 20.001 20.003" component={FilterGreen} />;
    default:
      return <SvgIcon {...props} viewBox="0 0 20.001 20.003" component={FilterWhite} />;
  }
};

export const AddIcon: React.FC<IIconsBaseProps> = ({ svgColor: svgColor = "white", ...props }) => {
  return <AddWhite fill={svgColor} viewBox="0 0 14.42 15" {...props} />;
};

export const CalendarIcon: React.FC<IIconsBaseProps> = ({ svgColor: svgColor = "black", ...props }) => {
  switch (svgColor) {
    case "green":
      return <SvgIcon {...props} viewBox="0 0 25 25" component={CalendarGreen} />;
    case "black":
      return <SvgIcon {...props} viewBox="0 0 25 25" component={CalendarBlack} />;
    default:
      return <SvgIcon {...props} viewBox="0 0 25 25" component={CalendarWhite} />;
  }
};

export const DeleteIcon: React.FC<IIconsBaseProps> = ({ svgColor: svgColor = "white", ...props }) => {
  switch (svgColor) {
    case "green":
      return <SvgIcon viewBox="0 0 20 20" {...props} component={Delete} />;
    case "red":
      return <SvgIcon viewBox="0 0 20 20" {...props} component={Delete} color="error" />;
    case "disabled":
      return <SvgIcon viewBox="0 0 20 20" {...props} component={Delete} color="disabled" />;
    default:
      return <SvgIcon viewBox="0 0 20 20" {...props} component={DeleteWhite} />;
  }
};

export const MenuDrawerIcon: React.FC<IIconsBaseProps> = ({ svgColor: svgColor = "white", ...props }) => {
  switch (svgColor) {
    case "green":
      return <SvgIcon {...props} viewBox="0 0 30 30" component={MenuOpenGreen} />;
    default:
      return <SvgIcon {...props} viewBox="0 0 30 30" component={MenuOpenWhite} />;
  }
};

export const MenuBurgerIcon: React.FC<IIconsBaseProps> = ({ svgColor: svgColor = "white", ...props }) => {
  switch (svgColor) {
    case "green":
      return <SvgIcon {...props} viewBox="0 0 30 30" component={MenuBurgerGreen} />;
    default:
      return <SvgIcon {...props} viewBox="0 0 30 30" component={MenuBurgerWhite} />;
  }
};

export const ShowHistoryIcon: React.FC<IIconsBaseProps> = ({ svgColor: svgColor = "white", ...props }) => {
  switch (svgColor) {
    case "green":
      return (
        <SvgIcon
          {...props}
          viewBox="0 0 24 21.001"
          style={{ flex: 1, paddingRight: "2px" }}
          component={ShowHistoryGreen}
        />
      );
    default:
      return (
        <SvgIcon
          {...props}
          viewBox="0 0 24 21.001"
          style={{ flex: 1, paddingRight: "2px" }}
          component={ShowHistoryWhite}
        />
      );
  }
};

export const CsvExportIcon: React.FC<IIconsBaseProps> = (props) => {
  return <SvgIcon {...props} viewBox="0 0 22 22" component={CsvExportWhite} />;
};

export const GRSLogo: React.FC<IIconsBaseProps> = (props) => <GRSNameLogo {...props} />;
export const GRSLogoDev: React.FC<IIconsBaseProps> = (props) => <GRSNameLogoDev {...props} />;

export const PomPlatformLogo: React.FC<IIconsBaseProps> = (props) => <PomPlatform {...props} />;
export const BatteryPickupPlatformLogo: React.FC<IIconsBaseProps> = (props) => <BatteryPickup {...props} />;
